import type { LucideIcon } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';

/**
 * Bloc d'un écran, **le seul cadre de l'interface** (proposition-pages.md § 9) : titre,
 * pictogramme, compteur et actions facultatifs. Variantes : `default` (bloc titré), `aside`
 * (résumé d'une fiche : titre discret en capitales, ni actions ni formulaire), et sans `title`
 * une simple carte (ancien `Card`).
 */
export function Panel({
  title,
  icon: Icon,
  actions,
  children,
  count,
  className,
  variant = 'default',
}: {
  title?: string | undefined;
  icon?: LucideIcon | undefined;
  actions?: ReactNode;
  children: ReactNode;
  count?: number | undefined;
  className?: string | undefined;
  variant?: 'default' | 'aside';
}): ReactElement {
  const classes = ['o-panel'];
  if (variant === 'aside') classes.push('o-panel--aside');
  if (title === undefined) classes.push('o-panel--plain');
  if (className !== undefined) classes.push(className);
  return (
    <section className={classes.join(' ')}>
      {title !== undefined && (
        <header className="o-panel__header">
          <h2 className="o-panel__title">
            {Icon !== undefined && <Icon aria-hidden="true" size={variant === 'aside' ? 16 : 18} />}
            {title}
            {count !== undefined && <span className="o-count">{count}</span>}
          </h2>
          {actions !== undefined && <div className="o-panel__actions">{actions}</div>}
        </header>
      )}
      <div className="o-panel__body">{children}</div>
    </section>
  );
}
